import { filter } from 'ramda';

// NOTE: Only remove if value is explicitly false, not just falsy
const removeRestrictedContexts =
  filter(con => !(con.userHasAccess === false));

export default removeRestrictedContexts;
